module.exports = __webpack_public_path__ + "static/media/stop-vaping-news.d43aa608.jpg";